import { createContext, useContext } from 'react'
import PropTypes from 'prop-types'
import ImageKit from 'imagekit'

const ImageKitContext = createContext()

const imagekit = new ImageKit({
  publicKey: 'public_9tPfWGySE7jcWdrvcnWt/HCc1sw=',
  privateKey: 'private_LDzHwSEwzszD7d87bqRdRKq8WKw=',
  urlEndpoint: 'https://ik.imagekit.io/natalu'
})

export const ImageKitProvider = ({ children }) => {
  const uploadImage = async (file, fileName) => {
    try {
      const response = await imagekit.upload({
        file,
        fileName
      })
      return {
        url: response.url,
        filePath: response.filePath,
        fileId: response.fileId
      }
    } catch (error) {
      console.error('Error uploading image:', error)
      throw error
    }
  }

  const getImages = async (path = '/') => {
    try {
      const images = await imagekit.listFiles({
        path,
      })
      return images
    } catch (error) {
      console.error('Error fetching images:', error)
      throw error
    }
  }

  const deleteImage = async fileId => {
    try {
      await imagekit.deleteFile(fileId)
    } catch (error) {
      console.error('Error deleting image:', error)
      throw error
    }
  }

  return (
    <ImageKitContext.Provider value={{ uploadImage, getImages, deleteImage }}>
      {children}
    </ImageKitContext.Provider>
  )
}

export const useImageKit = () => {
  const context = useContext(ImageKitContext)
  if (!context) {
    throw new Error('useImageKit must be used within an ImageKitProvider')
  }
  return context
}

ImageKitProvider.propTypes = {
    children: PropTypes.object.isRequired
}
